<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="brandingReportSetting"
      :model="model"
      entity-name="报告设置"
    />
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import BrandingManage from '@/model/dataLayer/api/branding/BrandingManage'

export default {
  components: { IkDataTable },
  data: function () {
    return ({
      model: BrandingManage
    })
  }
}
</script>
